import { tsValidateEnum, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { ProviderChatStatus } from './types.js';
import { Validator_EncounterId } from '../_core/validator.js';
import { AdvisorRuntimeIDBGroup } from '../_core/consts.js';
const Validator_ProvideChat = {
    ...Validator_EncounterId,
    providerId: tsValidateUniqueId,
    title: tsValidateString(),
    status: tsValidateEnum(ProviderChatStatus),
};
const Validator_GeneratedProps = {};
export const DBDef_ProviderChat = {
    modifiablePropsValidator: Validator_ProvideChat,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'provider-chat',
    entityName: 'Provider Chat',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'provider-chat'
    },
    backend: {
        name: 'provider-chat'
    }
};
//# sourceMappingURL=db-def.js.map